import { styled } from '@mui/material/styles';

import BottomSheet from 'src/components/BottomSheet';

export const Container = styled('div')({
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  padding: '4rem ',
  overflow: 'hidden',
});

export const ContentsContainer = styled('div')({});

export const Header = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  flexShrink: 0,
});

export const TxInfoContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',

  padding: '2.4rem',

  borderRadius: '1rem',

  backgroundColor: theme.colors.base06,

  rowGap: '1.3rem',
}));

export const TxInfoItemContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',

  color: theme.colors.base01,
}));

export const TxInfoItemColumnContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  rowGap: '0.8rem',

  color: theme.colors.base01,
}));

export const TxInfoItemLeftContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));

export const TxInfoItemRightContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '0.8rem',
});

export const TxInfoItemRightAmountColumnContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',

  rowGap: '0.4rem',
});

export const TxInfoItemRightAmountContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const SymbolContainer = styled('div')({
  maxWidth: '6rem',

  wordBreak: 'keep-all',
  whiteSpace: 'nowrap',

  '& > *': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export const Divider = styled('div')(({ theme }) => ({
  margin: '1rem 0',

  border: 0,

  borderTop: `0.1rem solid ${theme.colors.base04}`,
}));

export const HeaderTitle = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

export const DescriptionContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,

  margin: '2.7rem 0 3rem',
  whiteSpace: 'pre-wrap',
}));

export const StyledBottomSheet = styled(BottomSheet)({
  '& .MuiPaper-root': {
    height: '71rem',
    position: 'absolute',
    bottom: '0',
  },
});

export const IconContainer = styled('div')({
  width: '2.4rem',
  height: '2.4rem',
  '& > svg': {
    width: '2.4rem',
    height: '2.4rem',
  },
});
